import { UseQueryOptionsWithoutQueryKey } from '../../../react-query-config'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { useQuery } from '@tanstack/react-query'
import { ResponseApiError } from '../../../models/axios-error'

export interface UseApiGetWeekGmvForecastGapIndicatorsRequest {
  channel: 'INSTORE' | 'OMNI'
  storeId: number
  week: string
}

export interface WeekGmvForecastGapIndicatorsResponse {
  directorGmv: number
  teamsGmv: number
  trajectoryGmv: number
}

const getWeekGmvForecastGapIndicators = async (
  config: AxiosRequestConfig
): Promise<WeekGmvForecastGapIndicatorsResponse> => {
  const axiosPromise: AxiosResponse<WeekGmvForecastGapIndicatorsResponse> = await axios(config)
  return {
    ...axiosPromise.data
  }
}

export const useApiGetWeekGmvForecastGapIndicators = (
  args: UseApiGetWeekGmvForecastGapIndicatorsRequest,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<WeekGmvForecastGapIndicatorsResponse>
) => {
  const { storeId, channel, week } = args
  const url = `/v2/week-gross-merchandise-value-forecast-gap-indicators?channel=${channel}&storeId=${storeId}&week=${week}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<WeekGmvForecastGapIndicatorsResponse, ResponseApiError>({
    queryKey: ['get-week-gmv-forecast-gap-indicators', url],
    queryFn: () => getWeekGmvForecastGapIndicators(config),
    enabled,
    ...options
  })
}
